<template>
  <div class="wrapper-page">
    <div class="text-center">
      <a class="logo-lg">
        
        <img src="@/assets/logo.png" style="width: 100%;">
      </a>
    </div>

    <div class="alert alert-danger" v-if="loginError">
      <strong>Attenzione!</strong> Le credenziali immesse non sono valide.
    </div>

    <div>
      <div class="form-group row mt-4">
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="mdi mdi-account"></i>
              </span>
            </div>
            <input class="form-control" type="text" required placeholder="Username" v-model="username" />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="mdi mdi-key"></i>
              </span>
            </div>
            <input class="form-control" type="password" required placeholder="Password" v-model="password" />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-12">
          <i class="mdi mdi-road"></i>
          <span>RoadApp</span>
          &copy; ANCSERVIZI 2020
        </div>
      </div>

      <div class="form-group text-right m-t-20">
        <div class="col-xs-12">
          <button
            class="btn btn-primary btn-custom w-md waves-effect waves-light"
            @click="provideLogin()"
          >Log In</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data(){
    return {
      username: '',
      password: '',
      loginError: false
    }
  },

  methods: {
    provideLogin () {
      var jsonBody = {
        username: this.username,
        password: this.password
      }
      this.axios.post(`login`, jsonBody).then(response=>{
        if(response.data['success']){
          localStorage.setItem('token', response.data['auth_token']);
          localStorage.setItem('tipologia', response.data['tipologia']);
          this.$router.push({name: 'home'})
        } else {
          this.loginError = true;
        }
      },
      error => {
        console.log(error);
        this.loginError = true;
      })
    }
  }
};
</script>

<style>
</style>